/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum EditArticleResult {
  Success = 0,
  Error = 1,
  TenantNotFound = 2,
  TenantMismatch = 3,
  ArticleNotFound = 4,
  ValidationFailed = 5,
}
